export interface CircularGaugeProps {
  value: number
  label: string
  size?: number
  strokeWidth?: number
  color?: string
  unit?: string
}

export function CircularGauge({
  value,
  label,
  size = 96,
  strokeWidth = 8,
  color = '#e8660d',
  unit = '%',
}: CircularGaugeProps) {
  const clamped = Math.min(100, Math.max(0, value))
  const r = (size - strokeWidth) / 2
  const cx = size / 2
  const cy = size / 2
  const circumference = 2 * Math.PI * r
  const offset = circumference - (clamped / 100) * circumference

  return (
    <div className="flex flex-col items-center gap-1">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90" aria-hidden="true">
          <circle
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            stroke="#f2f0ed"
            strokeWidth={strokeWidth}
          />
          <circle
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{ transition: 'stroke-dashoffset 0.4s ease' }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-heading text-xl font-bold text-[#1a1714] leading-none">
            {Math.round(clamped)}
          </span>
          <span className="text-[10px] text-[#9a9589]">{unit}</span>
        </div>
      </div>
      <span className="text-xs font-medium text-[#9a9589]">{label}</span>
    </div>
  )
}
